export default "__VITE_ASSET__IAOkuqm4__"